import axios from "axios";
import { gConst } from "./gConst"; 
const env = process.env.REACT_APP_LOG_LEVEL;
const host = process.env[gConst.REACT_APP_COUCHDB_UAT_HOST] || process.env.REACT_APP_COUCHDB_UAT_HOST;
const password = process.env[gConst.REACT_APP_COUCHDB_UAT_PASSWORD] || process.env.REACT_APP_COUCHDB_UAT_PASSWORD;
const username = process.env[gConst.REACT_APP_COUCHDB_UAT_USERNAME] || process.env.REACT_APP_COUCHDB_UAT_USERNAME;

function gdebug(level,...args){
  try{
    if(+env >= level ) {
      console.log.apply(console, args);
    }else if (level === 5){
      console.log.apply(console, args);
      axios.post(host+args[0], {timestamp: new Date(), log: args}, 
        {
          auth: 
          {
            username: username, 
            password: password
          }
        }).then(result=>console.log("gdebug couchdb result", result))
    }
  }
  catch(e){
    console.log(e.message)
  }
}
export { gdebug };